import { render, staticRenderFns } from "./HotelDescriptionTerritory.vue?vue&type=template&id=0a98347e&"
import script from "./HotelDescriptionTerritory.vue?vue&type=script&setup=true&lang=ts&"
export * from "./HotelDescriptionTerritory.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./HotelDescriptionTerritory.vue?vue&type=style&index=0&id=0a98347e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports